import { render, staticRenderFns } from "./WindDirectionLastHourCard.vue?vue&type=template&id=1700a6ac&scoped=true&"
import script from "./WindDirectionLastHourCard.vue?vue&type=script&lang=js&"
export * from "./WindDirectionLastHourCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1700a6ac",
  null
  
)

export default component.exports